var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"backButtonRoute":'/home',"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig,"persistenceKey":'gl-account-list',"customMessages":_vm.customMessages}})
}
var staticRenderFns = []

export { render, staticRenderFns }